import { getNotificationDestination } from "./get-notification-destination.js";
import { NotificationsViewModel } from "./viewmodels/NotificationsViewModel.js";
import { singleton } from "mvc-kit";
//#region src/modules/Notifications/open-notification.ts
/**
* Row/toast click behavior: mark read, then navigate. Web-apps are separate
* SPAs, so navigation is a full page load — AWAIT the mark-read or the
* unload kills the in-flight call and the badge never clears.
*/
async function openNotification(item) {
	if (!item.read) await singleton(NotificationsViewModel).markRead(item.notificationId).catch(() => {});
	window.location.assign(getNotificationDestination(item));
}
//#endregion
export { openNotification };

//# sourceMappingURL=open-notification.js.map